import { Core } from '../../core';
import { ColorPartDto, ColorPartEntity } from '../interfaces';

export const ColorPartsStore = Core.Stores.create<ColorPartEntity, ColorPartDto>('/parts/colors');
